import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "table-top" }
const _hoisted_5 = { class: "table-tip" }
const _hoisted_6 = { class: "tip-item" }
const _hoisted_7 = { class: "tip-item" }
const _hoisted_8 = { class: "tip-item" }
const _hoisted_9 = { class: "tip-item" }
const _hoisted_10 = { class: "table" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            inline: true,
            model: _ctx.formSearch,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "账单日期" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.formSearch.projectTime,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formSearch.projectTime) = $event)),
                    type: "daterange",
                    class: "date-solt point",
                    "unlink-panels": "",
                    "range-separator": "至",
                    "start-placeholder": "生效日期",
                    "end-placeholder": "截止日期",
                    format: "YYYY-MM-DD",
                    "value-format": "YYYY-MM-DD",
                    style: {"width":"241px","margin-right":"20px"}
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.onSearch
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("搜索")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, { onClick: _ctx.onReset }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("重置")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onShowExport
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("导出")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, "实付总额：¥" + _toDisplayString(_ctx.totalValue1), 1),
        _createElementVNode("span", _hoisted_7, "保费总额：¥" + _toDisplayString(_ctx.totalValue2), 1),
        _createElementVNode("span", _hoisted_8, "超赔总额：¥" + _toDisplayString(_ctx.totalValue3), 1),
        _createElementVNode("span", _hoisted_9, "会员卡抵扣卷：¥" + _toDisplayString(_ctx.totalValue4), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%","min-height":"550px"},
          "header-cell-style": { background: '#FBFBFD' },
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' },
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "交易单号",
              "min-width": "180",
              prop: "flowNum"
            }),
            _createVNode(_component_el_table_column, {
              label: "类型",
              align: "center",
              prop: "paymentStatus"
            }, {
              default: _withCtx((scope) => [
                (scope.row.paymentStatus == 0 )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, " 支付"))
                  : _createCommentVNode("", true),
                (scope.row.paymentStatus == 1 )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, "退款 "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "账期",
              "min-width": "130",
              prop: "insureDay"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "支付时间",
              "min-width": "140",
              prop: "createTime"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "方案名称",
              "min-width": "160",
              prop: "insureCompanyPlanName"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "在保人次",
              prop: "totalPersons"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "保费总额",
              "min-width": "120",
              prop: "totalInsuranceFee"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "超赔总额",
              "min-width": "120",
              prop: "increaseInsuranceFee"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "会员卡抵扣劵",
              "min-width": "160",
              prop: "membershipCardDeduction"
            }),
            _createVNode(_component_el_table_column, {
              align: "center",
              label: "实付总额",
              "min-width": "120",
              prop: "realPay"
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.initTableList
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showExport,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showExport) = $event)),
      title: "导出账单",
      width: "400px",
      onCancel: _ctx.onCancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.exportData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "账单类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.exportData.billType,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.exportData.billType) = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("账单列表")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("账单明细")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.exportData.billType === 2)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "派遣单位"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.exportData.serveCompanyId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.exportData.serveCompanyId) = $event)),
                      multiple: "",
                      clearable: "",
                      placeholder: "请选择派遣单位",
                      onFocus: _ctx.onInitServeCompanyOptions
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serveCompanyOptions, (i) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: i.serveCompanyName,
                            value: i.serveCompanyName
                          }, null, 8, ["label", "value"]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onFocus"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "月度账单" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.exportData.date,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.exportData.date) = $event)),
                  "value-format": "YYYY-MM",
                  type: "month",
                  placeholder: "请选择",
                  clearable: false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("导出")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onCancel"])
  ]))
}